module.exports = __webpack_public_path__ + "static/media/client_top_page_header.db10918a.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/client_top_page_header.png
// module id = 508
// module chunks = 0